module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "worker.2a57633e.png";